
import React from 'react';
import { format } from 'date-fns';
import { FileText } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import ROUTES from '@/routes-map';

interface PatientHeaderProps {
  patientId: string;
  patientName: string;
  createdDate: string;
  status: string;
}

const PatientHeader: React.FC<PatientHeaderProps> = ({ 
  patientId, 
  patientName, 
  createdDate, 
  status 
}) => {
  const navigate = useNavigate();
  const formattedDate = format(new Date(createdDate), 'MMMM dd, yyyy');
  
  const goToPostTreatment = () => {
    navigate(`/post-treatment/${patientId}`);
  };
  
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
      <div>
        <h1 className="text-2xl font-bold">{patientName}</h1>
        <p className="text-muted-foreground">
          Case File • Created {formattedDate}
        </p>
      </div>
      <div className="flex flex-col sm:flex-row gap-2">
        {status === 'completed' ? (
          <Button
            onClick={goToPostTreatment}
            variant="outline"
          >
            <FileText className="mr-2 h-4 w-4" />
            View/Edit Post-Treatment Report
          </Button>
        ) : (
          <Button
            onClick={goToPostTreatment}
          >
            <FileText className="mr-2 h-4 w-4" />
            Create Post-Treatment Report
          </Button>
        )}
      </div>
    </div>
  );
};

export default PatientHeader;
